module.exports = __webpack_public_path__ + "static/media/calculated-plus-icon.dfc95296.svg";